import { FORM_TYPE, OPTION_LIST_TYPES } from "../custom-define-type";
import {
    DEFAULT_TABLE_FIELDS_OPTIONS, DEFAULT_USER_EXPORT_OPTIONS,
    USER_EXPORT_OPTIONS,
    DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
    ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS,
    DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS
} from "../default-values";

export const CANDIDATE_TABLE_SETTINGS = [
    {
        key: "CANDIDATE_TABLE_FIELD",
        model: "candidate_table_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: DEFAULT_TABLE_FIELDS_OPTIONS,
        hasAdminLevelSetting: true
    },
    {
        key: "CANDIDATE_TABLE_SEARCH_FIELD",
        model: "advance_setting.candidate_search_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: DEFAULT_TABLE_FIELDS_OPTIONS
    },
    {
        key: "CANDIDATE_DEFAULT_SORT_FIELD",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: 'sort_candidates_by',
        optionList: [],
        optionLabel: "label",
        optionModel: "model"
    },
    {
        key: "CANDIDATE_LAST_LOGIN_RETRIEVAL_DAYS",
        isIntegerField: true,
        model: 'candidate_last_login_retrieval_days',
    },
    {
        key: "USER_STATUS_STATISTICAL_BREAKDOWN",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'show_user_status_stats',
    },
    {
        key: "CANDIDATE_EACH_STATUS_COLOR",
        type: FORM_TYPE.STATUS_COLOR_INPUT,
        fieldLabel: "Status",
        optionListModel: 'candidate_statuses',
        hasInitElement: false,
        model: "candidate_table_status_color",
    },
    {
        key: "CANDIDATE_EACH_TYPE_COLOR",
        type: FORM_TYPE.COLOR_INPUT,
        fieldLabel: "Type",
        optionListModel: 'candidate_types',
        hasInitElement: false,
        model: "advance_setting.candidate_table_types_color",
    },
    {
        key: "CANDIDATE_EACH_TAG_COLOR",
        type: FORM_TYPE.COLOR_INPUT,
        fieldLabel: "Tag",
        optionListModel: 'candidate_tags',
        hasInitElement: false,
        model: "advance_setting.candidate_table_tags_color",
    },
    {
        key: "CANDIDATE_STATUS_TO_HIDE_DASHBOARD",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'candidate_statuses_to_hide',
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'candidate_statuses',
    },
    {
        key: "SHOW_CANDIDATE_DIALOG_IN_RIGHT_PANEL",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.show_candidate_dialog_in_right',
    },
];

export const EMPLOYER_VIEWS_SETTING = [
    {
        key: 'EMPLOYER_ADMIN_SHARE_VIEWS',
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "advance_setting.employer_admin_share_views",
        default: false
    }
]

export const CANDIDATE_VIEWS_SETTING = [
    {
        key: 'CANDIDATE_ADMIN_SHARE_VIEWS',
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "advance_setting.candidate_admin_share_views",
        default: false
    }
]

export const EMPLOYER_TABLE_SETTINGS = [
    {
        key: "EMPLOYER_TABLE_FIELD",
        model: "employer_table_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: DEFAULT_TABLE_FIELDS_OPTIONS,
        hasAdminLevelSetting: true
    },
    {
        key: "EMPLOYER_TABLE_SEARCH_FIELD",
        model: "advance_setting.employer_search_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: DEFAULT_TABLE_FIELDS_OPTIONS
    },
    {
        key: "EMPLOYER_DEFAULT_SORT_FIELD",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: 'sort_clients_by',
        optionList: [],
        optionLabel: "label",
        optionModel: "model"
    },
    {
        key: "EMPLOYER_LAST_LOGIN_RETRIEVAL_DAYS",
        isIntegerField: true,
        model: 'client_last_login_retrieval_days',
    },
    {
        key: "USER_STATUS_STATISTICAL_BREAKDOWN",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'show_user_status_stats',
    },
    {
        key: "EMPLOYER_EACH_STATUS_COLOR",
        type: FORM_TYPE.STATUS_COLOR_INPUT,
        fieldLabel: "Status",
        optionListModel: 'employer_statuses',
        hasInitElement: false,
        model: "client_table_status_color",
    },
    {
        key: "EMPLOYER_EACH_TYPE_COLOR",
        type: FORM_TYPE.COLOR_INPUT,
        fieldLabel: "Type",
        optionListModel: 'employer_types',
        hasInitElement: false,
        model: "advance_setting.client_table_types_color",

    },
    {
        key: "EMPLOYER_EACH_TAG_COLOR",
        type: FORM_TYPE.COLOR_INPUT,
        fieldLabel: "Tag",
        optionListModel: 'employer_tags',
        hasInitElement: false,
        model: "advance_setting.client_table_tags_color",
    },
    {
        key: "EMPLOYER_STATUS_TO_HIDE_DASHBOARD",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'employer_statuses_to_hide',
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'employer_statuses',
    },
    {
        key: "SHOW_EMPLOYER_DIALOG_IN_RIGHT_PANEL",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.show_employer_dialog_in_right',
    },
];

export const EMPLOYER_CSV_EXPORT_SETTINGS_OPTIONS = [
    {
        key: "EMPLOYER_CSV_EXPORT_SETTINGS",
        model: "advance_setting.client_mailing_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: DEFAULT_USER_EXPORT_OPTIONS,
        optionList: USER_EXPORT_OPTIONS,
        predefinedOptionList: []
    },
    {
        key: "EXPORT_DURATION_STATUS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.export_employer_duration_status',
        isMulti: false,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'employer_statuses',
    }
]

export const CANDIDATE_CSV_EXPORT_SETTINGS_OPTIONS = [
    {
        key: "CANDIDATE_CSV_EXPORT_SETTINGS",
        model: "advance_setting.candidate_mailing_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: DEFAULT_USER_EXPORT_OPTIONS,
        optionList: USER_EXPORT_OPTIONS,
        predefinedOptionList: []
    },
    {
        key: "EXPORT_DURATION_STATUS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.export_candidate_duration_status',
        isMulti: false,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'candidate_statuses',
    }
]

export const EMPLOYER_ANALYTICS_DASHBOARD_SETTING_OPTIONS = [
    {
        key: "EMPLOYER_ANALYTICS_DASHBOARD_FIELDS",
        model: "advance_setting.client_analytics_dashboard_fields",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
        optionListType: OPTION_LIST_TYPES.EMPLOYER_LIST_FIELDS,
        onlySelectionField: true,
        predefinedOptionList: ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS,
        optionLabel: "label",
        optionModel: "model"
    }
]

export const CANDIDATE_ANALYTICS_DASHBOARD_SETTING_OPTIONS = [
    {
        key: "CANDIDATE_ANALYTICS_DASHBOARD_FIELDS",
        model: "advance_setting.candidate_analytics_dashboard_fields",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
        optionListType: OPTION_LIST_TYPES.CANDIDATE_LIST_FIELDS,
        onlySelectionField: true,
        predefinedOptionList: ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS,
        optionLabel: "label",
        optionModel: "model"
    }
]

export const USER_MANAGER_SETTING_OPTIONS = [
    {
        key: "LABEL_OF_ADMIN_MANAGER",
        type: FORM_TYPE.TEXTBOX,
        model: 'public_advance_setting.admin_manager_label'
    },
    {
        key: "HAS_SECOND_ADMIN_MANAGER",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.has_second_admin_manager',
    }
];

export const USER_SECOND_MANAGER_SETTING_OPTIONS = [
    {
        key: "LABEL_OF_SECOND_ADMIN_MANAGER",
        type: FORM_TYPE.TEXTBOX,
        model: 'public_advance_setting.second_admin_manager_label'
    }
]

export const REFERENCE_TABLE_SETTINGS = [
    {
        key: "REFERENCE_TABLE_FIELD",
        model: "advance_setting.reference_table_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: [
            ...DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS
        ],
        hasAdminLevelSetting: true,
        default: DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS
    }
]

export const CLIENT_ADMIN_NOTES_SETTING = [
    {
        key: "USE_ADMIN_NOTES_IN_INTAKE_NOTES",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.use_admin_notes_in_client_intake_note',
    }
];

export const EDITABLE_VIEW_CLIENT = [
    {
        key: "EDITABLE_VIEW_DEFAULT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.set_editable_view_default_client',
    }
];

export const EDITABLE_VIEW_CANDIDATE = [
    {
        key: "EDITABLE_VIEW_DEFAULT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.set_editable_view_default_candidate',
    }
];

export const CANDIDATE_ADMIN_NOTES_SETTING = [
    {
        key: "USE_ADMIN_NOTES_IN_INTERVIEW_NOTES",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.use_admin_notes_in_candidate_interview_note',
    }
];

export const CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS = [
    {
        key: "CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW",
        model: "advance_setting.candiate_tags_matching_options_candidate_table",
        type: FORM_TYPE.RADIO,
        default: 'All Of',
        optionList: ['All Of', 'Any Of', 'None Of']
    }
]


export const CANDIDATE_STATUS_TO_HIDE_DASHBOARD_SETTING = [
    {
        key: "CANDIDATE_STATUS_TO_HIDE_DASHBOARD",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'candidate_statuses_to_hide',
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'candidate_statuses',
    },
]

export const EMPLOYER_STATUS_TO_HIDE_DASHBOARD_SETTING = [
    {
        key: "EMPLOYER_STATUS_TO_HIDE_DASHBOARD",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'employer_statuses_to_hide',
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        optionListModel: 'employer_statuses',
    },
]

export const CANDIDATE_DASHBOARD_SEARCH_BAR_SETTING = [
    {
        key: "CANDIDATE_SEARCH_BAR_OPEN_BY_DEFAULT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.candidate_search_bar_open_by_default',
    }
];

export const EMPLOYER_DASHBOARD_SEARCH_BAR_SETTING = [
    {
        key: "EMPLOYER_SEARCH_BAR_OPEN_BY_DEFAULT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.employer_search_bar_open_by_default',
    }
];

export const EMPLOYER_DASHBOARD_STATS_SETTING = [
    {
        key: "STATUSES_INCLUDED_EMPLOYER_STATISTICS",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        searchable: true,
        optionListModel: "employer_statuses",
        model: 'public_advance_setting.employer_statistic_status',
    },

];

export const CANDIDATE_DASHBOARD_STATS_SETTING = [
    {
        key: "STATUSES_INCLUDED_CANDIDATE_STATISTICS",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        searchable: true,
        optionListModel: "candidate_statuses",
        model: 'public_advance_setting.candidate_statistic_status',
    },
];


// WEBPACK FOOTER //
// ./src/constants/agency-settings/user-dashboard.js